import React, { useRef, useEffect } from 'react';
import Header from '../../components/common/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

const PoliticaDePrivacidade = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const voltarInicio = () => {
        window.location.href = 'https://www.informezz.com.br/#/home';
    };

    return (
        <>
            <Header />

            <div ref={containerRef} className="pp-page">

                {/* Hero Banner */}
                <div className="pp-hero">
                    <div className="pp-hero__content">
                        <div className="pp-hero__icon">
                            <FontAwesomeIcon icon={faShieldAlt} />
                        </div>
                        <h1 className="pp-hero__title">Política de Privacidade</h1>
                        <p className="pp-hero__subtitle">Atualizado em 03/03/2026</p>
                    </div>
                </div>

                {/* Conteúdo */}
                <div className="pp-wrapper">

                    {/* Botão voltar topo */}
                    <button className="pp-back-btn" onClick={voltarInicio}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <span>Voltar à Página Inicial</span>
                    </button>

                    <div className="pp-card">

                        {/* Seção 1 */}
                        <section className="pp-section">
                            <h2 className="pp-section__title">
                                <span className="pp-section__number">1</span>
                                Introdução
                            </h2>
                            <div className="pp-section__body">
                                <p>
                                    A sua privacidade é muito importante para nós. Temos o compromisso de tratar seus dados pessoais com responsabilidade, transparência e em conformidade com a legislação vigente e com as melhores práticas de proteção de dados.
                                    Coletamos apenas as informações estritamente necessárias para fornecer nossos produtos e serviços. Sempre que houver coleta de dados, ela será realizada por meios legais, com seu conhecimento e consentimento, e informaremos de forma clara a finalidade da utilização.
                                    Os dados serão armazenados somente pelo tempo necessário para cumprir as finalidades informadas ou para atender obrigações legais. Adotamos medidas de segurança técnicas e administrativas adequadas para proteger suas informações contra perda, roubo, acesso não autorizado, divulgação, alteração ou qualquer forma de uso indevido.
                                    Não compartilhamos seus dados pessoais publicamente. O compartilhamento poderá ocorrer apenas quando exigido por lei ou quando necessário para a adequada prestação dos serviços, sempre respeitando os limites legais.
                                    Você pode optar por não fornecer determinadas informações pessoais, ciente de que essa decisão poderá limitar ou impedir a disponibilização de alguns serviços.
                                </p>
                                <p>
                                    Em caso de dúvidas sobre como tratamos os dados dos usuários de nossos produtos e serviços, ou sobre qualquer informação relacionada à privacidade e proteção de dados, entre em contato conosco pelo
                                    telefone <strong>(46) 3225-0131</strong> ou e-mail: <strong>informezz@informezz.com.br.</strong>
                                </p>
                                <p>
                                    Nossa política de privacidade se aplica a todos os produtos e serviços fornecidos pelas empresas: INFORMEZZ SISTEMAS PARA LOJAS LTDA inscrita no
                                    CNPJ n.º 45.720.244/0001-87, localizada no endereço Rua Xingu, 61 - Centro de Pato Branco, PR. Entre os produtos e serviços, está o software ERP
                                    para lojas de calçados e roupas, o site{' '}
                                    <a href="http://www.informezz.com.br" target="_blank" rel="noopener noreferrer">www.informezz.com.br</a>
                                    {' '}e aplicativos mobile pertencentes a nossa empresa.
                                </p>
                                <p>
                                    Na sequência será apresentado a forma como ocorrerá a coleta, tratamento, armazenamento e demais afins sobre os dados fornecidos pelo usuário.
                                </p>
                            </div>
                        </section>

                        <div className="pp-divider" />

                        {/* Seção 2 */}
                        <section className="pp-section">
                            <h2 className="pp-section__title">
                                <span className="pp-section__number">2</span>
                                Conceitos e Terminologias Utilizadas
                            </h2>
                            <div className="pp-section__body">
                                <p>Nesta política de privacidade, será utilizado as seguintes definições e terminologias:</p>
                                <dl className="pp-glossary">
                                    <div className="pp-glossary__item">
                                        <dt>Controlador</dt>
                                        <dd>é a pessoa natural ou jurídica, de direito público ou privado, a quem competem as decisões referentes ao tratamento de Dados Pessoais;</dd>
                                    </div>
                                    <div className="pp-glossary__item">
                                        <dt>Dados Pessoais</dt>
                                        <dd>significa quaisquer informações relacionadas a uma pessoa identificada ou identificável, incluindo identificadores eletrônicos;</dd>
                                    </div>
                                    <div className="pp-glossary__item">
                                        <dt>Dados Pessoais Sensíveis</dt>
                                        <dd>significa Dados Pessoais sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dados referentes à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural;</dd>
                                    </div>
                                    <div className="pp-glossary__item">
                                        <dt>LGPD</dt>
                                        <dd>é a Lei nº 13.709/2018, conhecida popularmente como Lei Geral de Proteção de Dados que prevê os direitos dos Titulares dos Dados, as bases legais para o tratamento de Dados Pessoais, obrigações e demais premissas envolvendo a segurança dos Dados Pessoais;</dd>
                                    </div>
                                    <div className="pp-glossary__item">
                                        <dt>Operador</dt>
                                        <dd>é a pessoa natural ou jurídica, de direito público ou privado, que realiza o tratamento de Dados Pessoais em nome do Controlador;</dd>
                                    </div>
                                    <div className="pp-glossary__item">
                                        <dt>Titular de Dados Pessoais</dt>
                                        <dd>é a pessoa natural a quem se referem os Dados Pessoais que são objeto de operações de tratamento;</dd>
                                    </div>
                                    <div className="pp-glossary__item">
                                        <dt>Tratamento de Dados Pessoais</dt>
                                        <dd>é qualquer operação realizada com Dados Pessoais, como as que se referem à coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.</dd>
                                    </div>
                                </dl>
                            </div>
                        </section>

                        <div className="pp-divider" />

                        {/* Seção 3 */}
                        <section className="pp-section">
                            <h2 className="pp-section__title">
                                <span className="pp-section__number">3</span>
                                Consentimento por Parte do Usuário
                            </h2>
                            <div className="pp-section__body">
                                <p>
                                    O uso continuado do nosso site, produtos e serviços será considerado como aceitação de nossas práticas em torno de privacidade e informações pessoais.
                                </p>
                            </div>
                        </section>

                        <div className="pp-divider" />

                        {/* Seção 4 */}
                        <section className="pp-section">
                            <h2 className="pp-section__title">
                                <span className="pp-section__number">4</span>
                                A Quem Se Aplica
                            </h2>
                            <div className="pp-section__body">
                                <p>
                                    Esta Política aplica-se a todas as pessoas que acessarem ou utilizarem o site da Informezz, bem como suas funcionalidades e serviços.
                                    Também se aplica às pessoas físicas ou jurídicas que mantenham qualquer tipo de relação comercial com a nossa empresa.
                                </p>
                            </div>
                        </section>

                        <div className="pp-divider" />

                        {/* Seção 5 */}
                        <section className="pp-section">
                            <h2 className="pp-section__title">
                                <span className="pp-section__number">5</span>
                                Dados Coletados
                            </h2>
                            <div className="pp-section__body">
                                <p>
                                    A Informezz poderá coletar e armazenar dados pessoais inseridos ativamente pelo usuário no site, ou dados informados pelo usuário para fins de cadastro como: nome,
                                    nome da empresa, número de telefone, endereço, e-mail (profissional e/ou pessoal), cargo, CPF, RG, CNPJ, Inscrição Estadual, e demais informações que poderão ser solicitadas.
                                </p>
                            </div>
                        </section>

                        <div className="pp-divider" />

                        {/* Seção 6 */}
                        <section className="pp-section">
                            <h2 className="pp-section__title">
                                <span className="pp-section__number">6</span>
                                Utilização de Dados
                            </h2>
                            <div className="pp-section__body">
                                <p>
                                    Os dados coletados pela Informezz têm como finalidade realizar o cadastro do cliente em nosso banco de dados, viabilizando o contato e o registro da utilização dos serviços prestados.
                                    Essas informações permitem identificar os produtos ou serviços contratados, possibilitando a prestação de assistência e suporte adequados. Também podem ser utilizadas para manter o cliente informado sobre alterações, melhorias e atualizações relacionadas aos nossos serviços.
                                    Além disso, os dados contribuem para oferecer um atendimento mais ágil, eficiente e personalizado, de acordo com as necessidades de cada cliente.
                                </p>
                            </div>
                        </section>

                        <div className="pp-divider" />

                        {/* Seção 7 */}
                        <section className="pp-section">
                            <h2 className="pp-section__title">
                                <span className="pp-section__number">7</span>
                                Compartilhamento de Dados com Terceiros
                            </h2>
                            <div className="pp-section__body">
                                <p>
                                    A Informezz poderá atuar em parceria com outras empresas para a adequada prestação de seus serviços. Nesses casos, poderá ser necessário compartilhar determinadas informações com essas empresas parceiras, sempre de forma limitada ao que for essencial para a execução das atividades contratadas.
                                    Destacamos que essas empresas poderão possuir políticas de privacidade próprias, aplicáveis à forma como realizam a coleta e o tratamento de dados. Sempre que houver compartilhamento, ele ocorrerá em conformidade com a legislação vigente e com as medidas de segurança adequadas.
                                </p>
                                <p>Fica facultado o compartilhamento dos dados nas seguintes hipóteses:</p>
                                <ul className="pp-list">
                                    <li>Com empresas e filiais que integrem o grupo econômico da Informezz, as quais adotem políticas de privacidade compatíveis com as diretrizes estabelecidas nesta Política.</li>
                                    <li>Com empresas parceiras essenciais para a execução dos serviços contratados e para o desenvolvimento das atividades comerciais.</li>
                                    <li>Mediante solicitação judicial ou determinação legal que exija o fornecimento de dados do Titular, bem como para a proteção de direitos e interesses da Informezz em qualquer tipo de conflito.</li>
                                </ul>
                                <p>
                                    A Informezz assegura que, sempre que houver necessidade de compartilhamento, este será realizado em conformidade com a legislação brasileira vigente e com a adoção das melhores práticas de segurança da informação.
                                </p>
                                <p>
                                    Caso surja a necessidade de compartilhamento em situações não previstas neste item, isso ocorrerá apenas com o seu prévio conhecimento e consentimento.                                </p>
                            </div>
                        </section>

                        <div className="pp-divider" />

                        {/* Seção 8 */}
                        <section className="pp-section">
                            <h2 className="pp-section__title">
                                <span className="pp-section__number">8</span>
                                Armazenamento e Manutenção dos Dados
                            </h2>
                            <div className="pp-section__body">
                                <p>
                                    As informações coletadas são armazenadas em servidores próprios da empresa ou em servidores contratados especificamente para essa finalidade, observando critérios adequados de segurança e confidencialidade.
                                </p>
                            </div>
                        </section>

                        <div className="pp-divider" />

                        {/* Seção 9 */}
                        <section className="pp-section">
                            <h2 className="pp-section__title">
                                <span className="pp-section__number">9</span>
                                Tempo de Armazenamento
                            </h2>
                            <div className="pp-section__body">
                                <p>
                                    Os dados são mantidos pelo período necessário à prestação dos serviços contratados. Após esse prazo, poderemos reter as informações indispensáveis para fins de registro e histórico dos serviços utilizados, sempre respeitando os limites legais.
                                    Quando não houver mais necessidade de armazenamento, os dados serão excluídos de nossos registros e servidores de forma segura. O Titular também poderá solicitar a exclusão de suas informações a qualquer momento. A exclusão será realizada, salvo nos casos em que a manutenção dos dados seja necessária para cumprimento de obrigação legal, regulatória ou por determinação judicial.
                                </p>
                            </div>
                        </section>

                    </div>

                    {/* Botão voltar rodapé */}
                    <button className="pp-back-btn pp-back-btn--bottom" onClick={voltarInicio}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <span>Voltar à Página Inicial</span>
                    </button>

                </div>
            </div>
        </>
    );
};

export default PoliticaDePrivacidade;
